import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// Material Kit Components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Logo from "components/Brand/Logo";

// Button labels and paths from config
import navbarButtons from "config/navbarButtons";

export default function Navbar() {
  const navigate = useNavigate();

  return (
    // 🔹 Framer Motion animation: nav bar slides in from top
    <motion.nav
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      style={{
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 100,
      }}
    >
      <MKBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={3}
        py={2}
        bgcolor="white"
        boxShadow="md"
      >
        {/* 🔹 Logo section - clicking logo goes to homepage */}
        <MKBox
          display="flex"
          alignItems="center"
          sx={{ maxHeight: "64px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <Logo height={100} />
        </MKBox>

        {/* 🔹 Navigation Buttons generated from config */}
        <MKBox display="flex" alignItems="center" gap={1}>
          {navbarButtons.map((btn) => (
            <MKButton
              key={btn.label}
              variant={btn.variant || "text"}
              color="info"
              onClick={() => navigate(btn.path)}
              sx={{
                fontWeight: "bold",
                borderRadius: btn.variant === "gradient" ? "lg" : "md",
                "&:hover": {
                  transform: "scale(1.1)",
                  transition: "0.3s",
                },
              }}
            >
              {btn.label}
            </MKButton>
          ))}
        </MKBox>
      </MKBox>
    </motion.nav>
  );
}
